import * as Sentry from '@sentry/browser'

export const SentryInit = async () => {
    Sentry.init({
        dsn: 'https://68f945e4a9724f3daf8cc564fa0b004f@o784619.ingest.us.sentry.io/4509077205483520',
        integrations: [Sentry.browserTracingIntegration()],
        environment: import.meta.env.VITE_APP_NODE_ENV,
        release: import.meta.env.VITE_APP_SENTRY_RELEASE_NAME ?? 'unknown',
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            'https://staging-coachee.sama.io',
            'https://coachee.sama.io',
        ],
    })
    // if (stores.coachee.coachee) {
    //     Sentry.setUser({ id: stores.coachee.coachee._id })
    // }
}
